var _g, _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectionHandler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 70,
    viewBox: "0 0 75 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2607_32485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.5605,
    y: 21.6006,
    width: 24.3303,
    height: 18.7691,
    rx: 3.13758,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2557,
    y: 22.2957,
    width: 22.94,
    height: 17.3788,
    rx: 2.44243,
    stroke: "#1A2B3B",
    strokeWidth: 1.39031
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0537,
    y: 27.4873,
    width: 1.39031,
    height: 6.95153,
    rx: 0.695153,
    fill: "#1A2B3B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.9805,
    y: 27.4873,
    width: 1.39031,
    height: 6.95153,
    rx: 0.695153,
    fill: "#1A2B3B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9102,
    y: 27.4873,
    width: 1.39031,
    height: 6.95153,
    rx: 0.695153,
    fill: "#1A2B3B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2607_32485",
    x: 0.459881,
    y: 0.683363,
    width: 74.5314,
    height: 68.9709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.18344
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5503
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2607_32485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2607_32485",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectionHandler);
export default __webpack_public_path__ + "static/media/projection-handler.89bb98514e4b961f3126a43d6d02d095.svg";
export { ForwardRef as ReactComponent };